<template>
    <div class="wrapper">
    <div class="section page-header header-filter">
      <div class="container">
     <div class="md-layout">
          <div
            class="md-layout-item md-size-33 md-medium-size-40 md-small-size-50 md-xsmall-size-70 mx-auto text-center"
          >
          
          <div class="video-container">
  <div class="Centered">
  <div class="frame">
    <p>Vous êtes maintenant déconnecté.</p>
   <md-button href="/" type="submit" class="md-primary">Se reconnecter</md-button>
  </div>
</div>
  </div>
  </div>
  </div>
  </div>
 </div>
 </div>
</template>

<script>
import axios from "../../http-common";
import { mapGetters } from "vuex";
import { LOCAL_STORAGE } from "../../utils/localStorage";
export default {
  mounted() {
    // Appel à l'API de déconnexion
    axios.post("/api/auth/signout").then(() => {
      // Suppression des informations d'authentification
        LOCAL_STORAGE.REMOVE({ key: "auth" });
      //window.location.href = "/";
    });
  },
};
</script>
<style>
.Centered{
display: flex; 
justify-content: center; 
align-items: center; 
height: 100%; 
width: 600px;
margin-left: 20px;
margin-right: 20px;


}
.frame{
background-color: #F8F8F8; 
border: 1px solid #E0E0E0; 
border-radius: 4px; 
padding: 40px; 
text-align: center; 
box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
}
.frame p{
font-size: 24px;
font-weight: bold; 
margin-bottom: 20px; 
color:black
}
</style>